import styled from '@emotion/styled';
import {
  Container,
  ProLandingSectionContent,
  SideLayoutSideWrapper,
} from '@presentation/components';
import { mediaQuery } from '@presentation/styles';
import { FaChevronRight } from 'react-icons/fa';

export const SpaceSeparator = styled.div`
  height: 50px;
  width: 100%;
`;

export const PageContainer = styled(Container)`
  margin-bottom: 100px;
  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const MapWrapper = styled.div`
  width: 100%;
  height: 350px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const DetailListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 25px 0;
  & > *:not(:last-child) {
    margin-right: 40px;
  }
  ${mediaQuery('desktop')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 40px;
    }
    flex-direction: column;
  }
`;

export const DetailListTitle = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 600;
`;

export const DetailListWrapper = styled.div`
  width: calc(50% - 20px);
  ${mediaQuery('desktop')} {
    width: 100%;
  }
`;

export const DetailListIconWrapper = styled.span`
  color: ${(props) => props.theme.color.blue.default};
  margin-right: 10px;
`;

// Services
export const ServiceItem = styled.div<{ index: number }>`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
  justify-content: space-between;
  align-items: center;
  background: ${(props) =>
    props.index % 2 !== 0 ? props.theme.color.light.tint : props.theme.color.light.default};
  padding: 7px 20px;
  color: ${(props) => props.theme.color.medium.shade};
  font-size: 16px;
`;

export const ServiceSpecialistTag = styled.div`
  background: ${(props) => props.theme.color.yellow.default};
  color: ${(props) => props.theme.color.light.default};
  padding: 0px 15px;
  font-size: 12px;
  line-height: 26px;
  border-radius: 10px;
  font-weight: 700;
  margin: 0 10px;
  display: inline-block;
`;

export const ServiceLabel = styled.div<{ link: boolean }>`
  line-height: 32px;
  ${(props) =>
    props.link &&
    `
  cursor: pointer;
  font-weight: 600;
  &:hover {
    color: ${props.theme.color.blue.default};
  }
  `}
`;

export const ServiceChevronRight = styled(FaChevronRight)`
  margin-left: 5px;
  font-size: 16px;
`;

export const ServiceRightWrapper = styled.div`
  text-align: right;
`;

export const ServiceDuration = styled.div`
  display: inline-block;
  white-space: nowrap;
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 600;
`;

export const ServicePrice = styled.div`
  display: inline-block;
  white-space: nowrap;
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 600;
  margin-left: 20px;
  width: 150px;
  ${mediaQuery('phone')} {
    width: auto;
  }
`;

export const MapContainer = styled.div`
  height: 400px;
  margin-top: 30px;
  margin-bottom: 10px;
  position: relative;
  z-index: 0;
`;

export const ContactInfosContainer = styled.div`
  margin-bottom: 30px;
  padding-left: 50px;
  padding-right: 50px;
  max-width: 100%;
  position: relative;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  background: ${(props) => props.theme.color.light.default};
  border-radius: 15px;
  padding: 30px;
  ${mediaQuery('tablet')} {
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
`;

//EducatorContactInfos

export const EducatorContactInfosTitleWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
`;

export const EducatorContactInfosImg = styled.img`
  object-fit: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
`;

export const EducatorContactInfosType = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.color.medium.default};
  margin: 0;
`;

export const EducatorContactInfosLocationWrapper = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
  svg {
    color: ${(props) => props.theme.color.blue.default};
  }
  p {
    margin: 0;
  }
  margin-bottom: 20px;
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 6;
`;

export const StyledSideLayoutSideWrapper = styled(SideLayoutSideWrapper)`
  z-index: 7;
`;

/**
 * UNCLAIMED
 */

export const UnclaimedCard = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 25px;
  }

  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;

  z-index: 1;
  position: relative;
  padding: 20px 30px;
  background: ${(props) => props.theme.color.light.default};
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  margin: 40px 0;
  ${mediaQuery('tablet')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 25px;
    }
    margin: 20px 0;
    flex-direction: column;
  }
`;

export const UnclaimedCardText = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;

  ${mediaQuery('tablet')} {
    text-align: center;
  }

  ${mediaQuery('small')} {
    font-size: 16px;
  }
`;

export const StyledProLandingSectionContent = styled(ProLandingSectionContent)`
  padding: 0 !important;
  margin: 0 !important;
`;
export const ReviewWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const ReviewText = styled.div`
  font-size: 14px;
  margin-left: 4px;
  font-weight: 400;
`;

export const RelatedLinksContainer = styled.div`
  margin-top: 50px;
`;
